export default [
  {
    path: "/landingPage",
    component: () => import("@/layouts/blank.vue"),
    children: [
      {
        path: "",
        name: "landingPage",
        component: () => import("@/views/landingPage/index.vue"),
        meta: {
          mobilePath: "/landingPage",
          useShortMobileQuery: true,
          title: "落地页",
        },
      },
    ],
  },
];
